import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { isProductionEnvironment } from "utils/env";

import { TableColumnMeta } from "../../types";
import makeTableColumnsSlice from "./makeTableColumnsSlice";
import { mergeTablePersistedState } from "./mergePersistedState";
import { TableColumnsState } from "./types";

type UseTableStoreConfig = {
  storageKey: string;
  config: Record<string, TableColumnMeta>;
  version?: number;
};

const createTableStore = ({ storageKey, config, version = 1 }: UseTableStoreConfig) =>
  create<TableColumnsState>()(
    devtools(
      persist(
        immer((...a) => ({
          ...makeTableColumnsSlice(config)(...a),
        })),
        {
          name: storageKey,
          partialize: (state) => ({
            columnsOrder: state.columnsOrder,
            columnsSizes: state.columnsSizes,
            isFirstColumnPinned: state.isFirstColumnPinned,
          }),
          version,
          merge: mergeTablePersistedState,
        }
      ),
      { enabled: !isProductionEnvironment() }
    )
  );

export default createTableStore;
